import React, { useState } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Navbar from "../components/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import "./UserLayout.css";

const UserLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div
      className={`admin-layout ${isSidebarOpen ? "with-sidebar" : "no-sidebar"}`}
    >
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

      {/* Toggle button */}
      <button
        className="sidebar-toggle"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>

      {/* Main Content */}
      <div className="admin-main-content">
        <Navbar />
        <div className="admin-data-section">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default UserLayout;
